import React from "react";
import dynamic from "next/dynamic";
import Image from "@/component/c-image";

import style from "./style";
const Icon = dynamic(() => import("@gc-npm/components.icon-glyph"));

/**
 * Alert component
 * @param {string} props.iconType - The type of the icon
 * @param {string} props.srcImage - The source image URL
 * @param {object} props.textProps - The props for the Text component
 * @returns {React.ReactNode} The rendered Alert component
 */
const Alert = ({ hash = "", icon, srcImage, children, className = "", sx }) => {

  if (
    (!icon && !srcImage) ||
    (!children)
  ) {
    return null;
  }

  return (
    <div
      className={`alert ${className}`}
      style={sx}
    >
      {icon && icon.name && (
        <div className={`icon-container`} style={{ alignSelf: icon.flexAlign, margin: icon.margin }}>
          <div className={`icon ${icon.withBackground ? 'background' : ''}`} >
            <Icon id={icon.name} height={icon.height || 20} color={icon.color} />
          </div>
        </div>
      )}

      {srcImage && (
        <div className="image">
          <Image
            hash={hash}
            src={srcImage}
            alt="image-alert"
            objectFit="cover"
            width={20}
            height={20}
          />
        </div>
      )}
      {children}
      <style jsx>{style}</style>
    </div>
  );
};

export default Alert;
